import React from 'react';
import PropTypes from 'prop-types';
import './Loader.scss';

const Loader = ({ size = 'md', variant = 'primary', progress = null }) => {
   const isDeterminate = progress > 0;

   return (
      <div
         className={`loader ${variant} size-${size} ${isDeterminate ? 'determinate' : 'indeterminate'}`}
         style={
            isDeterminate
               ? { '--progress': progress } // only needed for progress
               : undefined
         }
      />
   );
};

Loader.propTypes = {
   size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', '2xl']),
   variant: PropTypes.oneOf(['primary', 'white', 'progress']),
   progress: PropTypes.number,
};

export default Loader;
